// extracted by mini-css-extract-plugin
module.exports = {"profile":"Layout_profile__6SjCv","content":"Layout_content__jpvrE","searchContainer":"Layout_searchContainer__t9_n_","share":"Layout_share__yWU_7"};